import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.CALENDARS)({
    component: CalendarsLayout,
    staticData: {
        config: {
            title: "calendars",
        },
    },
});

function CalendarsLayout() {
    return <Outlet />;
}
